import React from 'react';
import Spacer from "../../../../Components/Spacer";

const SubscriptionDetails = (props) => {
    const {
        subscription = {
            start_at:               null,
            amount:                 null,
            billed_interval_count:  null,
            billed_interval:        null,
            trial_period_days:      null,
            name:                   null
        }
    } = props;

    const renderDetailRow = (title, value) => {
        return (
            <tr>
                <th>{title}</th>
                <td>{value}</td>
            </tr>
        )
    }

    const renderBilling = () => {
        if (!subscription.billed_interval_count || !subscription.billed_interval) {
            return null;
        }

        return 'Every '+subscription.billed_interval_count+' '+subscription.billed_interval+'(s)';
    }

    return (
        <React.Fragment>
            <table className={'subscription-details'}>
                <tbody>
                {renderDetailRow('Name:', subscription.name)}
                {renderDetailRow('Amount:', subscription.amount)}
                {renderDetailRow('Start date:', subscription.start_at)}
                {renderDetailRow('Billed:', renderBilling())}
                {!!subscription.trial_period_days && renderDetailRow('Trial period (days):', subscription.trial_period_days)}
                </tbody>
            </table>
            <Spacer />
        </React.Fragment>
    );
}

export default SubscriptionDetails;
